/// <amd-module name="Test/TestPlansLibrary/ColumnOptions/TestCasesColumnOptionUtils" />
import { WorkItemDetails } from "TestPlanCommon/Contracts/TestPlan";

import {
    IColumnOptionKeyValuePair,
    WorkItemColumnOptions,
    CustomFieldColumn,
    isCustomField,
    getCustomFieldName
} from "./ColumnOptionsCommonUtils";

export function getAllPossibleFields(): IColumnOptionKeyValuePair[] {
    const allColumnOptionFields: IColumnOptionKeyValuePair[] = [];
    for (const key in WorkItemColumnOptions) {
        if (WorkItemColumnOptions[key] && WorkItemColumnOptions[key].testCasesPivot) {
            allColumnOptionFields.push({
                key: key,
                name: WorkItemColumnOptions[key].name
            });
        }
    }
    return allColumnOptionFields;
}

export function getWITColumnFields(columnOptionFields: string[]): string[] {
    const tableColumns: string[] = [];
    for (const columnOptionField of columnOptionFields) {
        if (WorkItemColumnOptions[columnOptionField] && WorkItemColumnOptions[columnOptionField].testCasesPivot) {
            tableColumns.push(columnOptionField);
        }
        if (isCustomField(columnOptionField)) {
            tableColumns.push(columnOptionField);
        }
    }
    return tableColumns;
}

export function getAllColumnFields(columnOptionFields: string[]): any {
    const tableColumns = [];
    for (const columnOptionField of columnOptionFields) {
        if (WorkItemColumnOptions[columnOptionField] && WorkItemColumnOptions[columnOptionField].testCasesPivot) {
            tableColumns.push({
                id: columnOptionField,
                name: WorkItemColumnOptions[columnOptionField].name
            });
        }
        if (isCustomField(columnOptionField)) {
            tableColumns.push(getCustomFieldName(columnOptionField));
        }
    }
    return tableColumns;
}

export function getAllColumnOptionsValues(testCase: WorkItemDetails): any {
    let columnOptions: any = {};
    const witColumnOptions = WorkItemColumnOptions;

    if (testCase && testCase.workItemFields) {
        // adds all workitem fields
        for (const columnOption of testCase.workItemFields) {
            columnOptions = { ...columnOptions, ...columnOption };
        }

        // parses all the workitem fields
        for (const columnOption in columnOptions) {
            if (witColumnOptions[columnOption] && witColumnOptions[columnOption].testCasesPivot) {
                columnOptions[columnOption] = witColumnOptions[columnOption].getDisplayValue(columnOptions[columnOption]);
            }

            // handle display value for custom fields
            if (isCustomField(columnOption)) {
                columnOptions[columnOption] = CustomFieldColumn.getDisplayValue(columnOptions[columnOption]);
            }
        }
    }
    return columnOptions;
}